import {
  BarChartOutlined,
  StarOutlined,
  ProfileOutlined,
  DollarOutlined,
  FolderAddOutlined,
} from "@ant-design/icons";
import Overview from "./views/Overview";
import Activities from "./components/overview/Activities";
import YearInSport from "./components/overview/YearInSport";
import Note from "./views/Note";
import Deposit from "./views/Deposit";

const router = [
  {
    path: "/",
    name: "Overview",
    icon: <ProfileOutlined />,
    roles: ["user"],
    component: Overview,
    menu: "main",
  },
  {
    path: "/athletes/:athlete_id",
    name: "Athlete Activities",
    icon: <FolderAddOutlined />,
    roles: ["user"],
    component: Activities,
    menu: "main",
  },
  {
    path: "/year-in-sport/:athlete_id/:year",
    name: "Athlete Year In Sport",
    icon: <FolderAddOutlined />,
    roles: ["user"],
    component: YearInSport,
    menu: "main",
  },
  {
    path: "/note",
    name: "Create Note",
    icon: <FolderAddOutlined />,
    roles: ["user"],
    component: Note,
    menu: "main",
  },
  {
    path: "/note/:note_id",
    name: "Update Note",
    icon: <FolderAddOutlined />,
    roles: ["user"],
    component: Note,
    menu: "main",
  },
  {
    path: "/deposit",
    name: "Deposit",
    icon: <DollarOutlined />,
    roles: ["user"],
    component: Deposit,
    menu: "main",
  },
];

export default router;
